export default __webpack_public_path__ + "static/media/netcare-digital-icon.fc81d9ed.svg";